import React from "react";
import PropTypes from "prop-types";
import Header from "./header";
import { Layout } from "@evertrue/et-components";
import { useChatNavigationContext } from "../contexts/chat-navigation-context";
import MemberList from "./member-list";

const ChatMemberList = ({ roomId, currentRoom }) => {
  const [, dispatchNav] = useChatNavigationContext();

  return (
    <Layout
      header={
        <Header
          title="Member List"
          showClose
          showBack
          onBack={() => dispatchNav({ type: "SELECT_ROOM", payload: roomId })}
        />
      }
    >
      <MemberList currentRoom={currentRoom} />
    </Layout>
  );
};

ChatMemberList.propTypes = {
  roomId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ChatMemberList;
